/**
 * 专家主数据（Layer 2: Master Data）
 *
 * 本文件仅包含人工录入/维护的专家基础信息字段。
 * 派生字段（stats, points, contentCount）由系统运行时自动计算，不在此硬编码。
 *
 * 字段标注规范：
 * @source MANUAL      — 人工录入
 * @mutability STATIC|SEMI_DYNAMIC
 * @consistency SSOT   — 单一数据源
 * @permission ADMIN|OPERATOR
 */

export const EXPERTS_MASTER = [
  {
    /** @field id @source SYSTEM @mutability STATIC @consistency SSOT @permission SYSTEM */
    id: 'e1',
    /** @field name @source MANUAL @mutability STATIC @consistency SSOT @permission ADMIN */
    name: '张建国',
    /** @field avatar @source MANUAL @mutability SEMI_DYNAMIC @consistency SSOT @permission OPERATOR */
    avatar: 'https://picsum.photos/seed/expert1/200/200',
    /** @field title @source MANUAL @mutability SEMI_DYNAMIC @consistency SSOT @permission OPERATOR */
    title: '前华为组织发展专家',
    /** @field department @source MANUAL @mutability STATIC @consistency SSOT @permission OPERATOR */
    department: '华为',
    /** @field position @source MANUAL @mutability SEMI_DYNAMIC @consistency SSOT @permission OPERATOR */
    position: '组织发展专家',
    /** @field bio @source MANUAL @mutability SEMI_DYNAMIC @consistency SSOT @permission OPERATOR */
    bio: '15年华为管理经验。核心心得：**管理不是管人，而是管事。** [gold]以奋斗者为本[/gold]是我们的底层逻辑。',
    /** @field quote @source MANUAL @mutability SEMI_DYNAMIC @consistency SSOT @permission OPERATOR */
    quote: '管理不是管人，而是管好"人与人之间的连接"。',
    /** @field topics @source MANUAL @mutability SEMI_DYNAMIC @consistency SSOT @permission OPERATOR */
    topics: ['执行力', '组织变革'],
    /** @field resume @source MANUAL @mutability SEMI_DYNAMIC @consistency SSOT @permission OPERATOR */
    resume: ['华为25年经验', '组织发展专家'],
    /** @field tags @source MANUAL @mutability SEMI_DYNAMIC @consistency SSOT @permission OPERATOR */
    tags: ['华为背景', '组织专家'],
    /** @field caseDocument @source MANUAL @mutability SEMI_DYNAMIC @consistency SSOT @permission OPERATOR */
    caseDocument: "核心复盘：针对扩张期人才流失，我们建立了'人才防火墙'机制。通过建立非正式沟通渠道和'影子教练'制度，有效缓解了新老员工之间的文化冲突，使人才留存率提升了30%。核心在于：目标必须颗粒度化，责任必须穿透到个人，且反馈必须是即时的。",
    /** @field audioTitle @source MANUAL @mutability SEMI_DYNAMIC @consistency SSOT @permission OPERATOR */
    audioTitle: '廖清红：关于管理中的人性博弈（原声节选）',
    /** @field videoTitle @source MANUAL @mutability SEMI_DYNAMIC @consistency SSOT @permission OPERATOR */
    videoTitle: "SOP 系列：如何通过'日清'机制实现目标穿透",

    // ===== 运营可调字段（人工干预，需审计留痕） =====
    /** @field recommendWeight @source OPERATOR @mutability SEMI_DYNAMIC @consistency MULTI_WRITE @permission OPERATOR 人工干预推荐权重 */
    recommendWeight: 0,
    /** @field isFeatured @source OPERATOR @mutability SEMI_DYNAMIC @consistency MULTI_WRITE @permission OPERATOR 是否首页推荐 */
    isFeatured: false,
    /** @field status @source ADMIN @mutability SEMI_DYNAMIC @consistency SSOT @permission ADMIN active/suspended/banned */
    status: 'active'
  },
  {
    id: 'e2',
    name: '李慕华',
    avatar: 'https://picsum.photos/seed/expert2/200/200',
    title: '360高级副总裁/资深教练',
    department: '360',
    position: '高级副总裁/资深教练',
    bio: '互联网老兵，深谙快速扩张期企业的团队凝聚力建设。曾助力多家创业公司完成从0到1组织搭建。',
    quote: '在不确定性中寻找确定性，是管理者的终身修行。',
    topics: ['团队建设', '快速扩张'],
    resume: ['360高级副总裁', '资深教练'],
    tags: ['互联网老兵', '资深教练'],
    caseDocument: "核心复盘：针对扩张期人才流失，我们建立了'人才防火墙'机制。在互联网企业快速扩张期，文化冲突是人才流失的主因。我们通过'文化软着陆'方案，引入'影子教练'制度，确保新人在入职前90天获得高频反馈与文化对齐。",
    audioTitle: '廖清红：关于管理中的人性博弈（原声节选）',
    videoTitle: "SOP 系列：如何通过'日清'机制实现目标穿透",
    recommendWeight: 0,
    isFeatured: false,
    status: 'active'
  },
  {
    id: 'e3',
    name: '陈志远',
    avatar: 'https://picsum.photos/seed/expert3/200/200',
    title: '字节跳动前HRBP负责人',
    department: '字节跳动',
    position: '前HRBP负责人',
    bio: '擅长OKR落地与绩效激励设计。对新生代员工管理有独到见解。',
    quote: '好的制度让坏人变好，坏的制度让好人变坏。',
    topics: ['OKR', '绩效管理'],
    resume: ['字节跳动HRBP', '绩效专家'],
    tags: ['绩效专家', '字节背景'],
    caseDocument: "核心复盘：针对扩张期人才流失，我们建立了'人才防火墙'机制。在字节跳动期间，我们发现OKR的成功不仅在于目标对齐，更在于激励机制的动态适配。通过建立'人才防火墙'，我们实现了核心人才的精准激励与长期留存。",
    audioTitle: '廖清红：关于管理中的人性博弈（原声节选）',
    videoTitle: "SOP 系列：如何通过'日清'机制实现目标穿透",
    recommendWeight: 0,
    isFeatured: false,
    status: 'active'
  },
  {
    id: 'e4',
    name: '王芳',
    avatar: 'https://picsum.photos/seed/expert4/200/200',
    title: '阿里巴巴组织文化布道师',
    department: '阿里巴巴',
    position: '组织文化布道师',
    bio: '15年阿里政委经验，擅长文化软实力建设与团队冲突解决。',
    quote: '文化不是挂在墙上的标语，而是员工下意识的行为。',
    topics: ['企业文化', '冲突解决'],
    resume: ['阿里政委15年', '文化布道师'],
    tags: ['阿里政委', '文化专家'],
    caseDocument: '',
    audioTitle: '',
    videoTitle: '',
    recommendWeight: 0,
    isFeatured: false,
    status: 'active'
  },
  {
    id: 'e5',
    name: '赵子龙',
    avatar: 'https://picsum.photos/seed/expert5/200/200',
    title: '腾讯学院资深讲师',
    department: '腾讯学院',
    position: '资深讲师',
    bio: '专注管理者领导力提升，累计辅导超过1000名中高层管理者。',
    quote: '领导力不是头衔，而是影响力。',
    topics: ['领导力', '管理培训'],
    resume: ['腾讯学院讲师', '领导力教练'],
    tags: ['领导力教练', '腾讯讲师'],
    caseDocument: '',
    audioTitle: '',
    videoTitle: '',
    recommendWeight: 0,
    isFeatured: false,
    status: 'active'
  }
]

/**
 * 专家派生数据初始状态（Layer 4: Derived）
 * 这些值仅在应用冷启动时使用，运行时会根据用户行为自动重算
 * @source AUTO @mutability REALTIME @consistency DERIVED @permission SYSTEM
 */
export const DEFAULT_EXPERT_STATS = {
  clicks: 0,
  plays: 0,
  bookmarks: 0,
  likes: 0,
  comments: 0
}

/**
 * 根据 stats 计算专家积分
 * @param {object} stats - 专家统计数据
 * @param {object} weights - 积分权重配置
 * @returns {number}
 */
export function calculateExpertPoints(stats, weights) {
  if (!stats) return 0
  return (
    (stats.clicks || 0) * (weights?.click || 1) +
    (stats.plays || 0) * (weights?.play || 2) +
    (stats.bookmarks || 0) * (weights?.bookmark || 5) +
    (stats.likes || 0) * (weights?.like || 5) +
    (stats.comments || 0) * (weights?.comment || 5)
  )
}

/**
 * 计算专家内容数量
 * @param {string} expertId - 专家ID
 * @param {object} casesMap - 案例字典
 * @returns {number}
 */
export function calculateExpertContentCount(expertId, casesMap) {
  if (!casesMap || !expertId) return 0
  return Object.values(casesMap).filter(c => c.expertId === expertId).length
}

/**
 * 为主数据专家附加派生数据，生成完整运行时专家对象
 * @param {object} master - 专家主数据
 * @param {object} stats - 统计数据（可选，默认零值）
 * @param {object} casesMap - 案例字典（用于计算 contentCount）
 * @param {object} scoringConfig - 积分权重配置
 * @returns {object} 完整的运行时专家对象
 */
export function composeExpert(master, stats = null, casesMap = null, scoringConfig = null) {
  const computedStats = stats || { ...DEFAULT_EXPERT_STATS }
  const points = calculateExpertPoints(computedStats, scoringConfig?.weights)
  const contentCount = calculateExpertContentCount(master.id, casesMap)

  return {
    ...master,
    stats: computedStats,
    points,
    contentCount
  }
}
